import styled from 'styled-components';

export const Container = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  font-family: 'Heebo', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  border: 1px solid #ffffff1f;
  border-radius: 16px;
  overflow: hidden;
`;
